class IngredientPills extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const button = event.target.closest('.ingredient-pills__item');
    if (!button) return;

    const section = this.closest('.ingredient-pills-section');
    const panel = section.querySelector('.ingredient-pills__panel');
    const dataScript = section.querySelector('[data-ingredient-pills-data]');
    if (!panel || !dataScript) return;

    const data = JSON.parse(dataScript.textContent);
    const index = parseInt(button.dataset.index, 10);
    const item = data[index];
    const isOpen = button.getAttribute('aria-expanded') === 'true';

    this.querySelectorAll('.ingredient-pills__item').forEach((el) => el.setAttribute('aria-expanded', 'false'));

    if (isOpen) {
      panel.hidden = true;
      return;
    }

    button.setAttribute('aria-expanded', 'true');
    panel.querySelector('.ingredient-pills__panel-name').textContent = item.name;
    panel.querySelector('.ingredient-pills__panel-text').textContent = item.description;
    panel.hidden = false;
  }
}

customElements.define('ingredient-pills', IngredientPills);
